import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import logo from '../../assets/companies/logo.png';
import Hamburger from '../../Components/MenuBurger';
import { MenuContext } from '../../utils/context';
import { ThemeContext } from '../../utils/context';

// Langage switch
import Lang from '../lang';


// Langage
import "../../i18n";
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';



const Logo = styled.img`
  height: 55px;
  object-fit: cover;
  transition: 0.5s;
  z-index: 3;
`;

const LinkNav = styled(Link)`
  color: ${props => (props.theme === 'light' ? '#4b4b4b' : '#f2f2f2')};
  font-weight: 500;
  margin: 0 20px;
  padding: 10px 20px;
  text-decoration: none;
  transition: color 0.3s ease-in-out;
  position: relative;

  &:hover {
    color: #0790ff;
  }
`;

const Dot = styled.div`
  position: absolute;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  background-color: #0790ff;
  border-radius: 50%;
  opacity: ${props => (props.$active ? '1' : '0')};
  transition: opacity 0.3s, transform 0.3s;
`;

const DotShop = function () {
  return (
    <div className="w-2 h-2 bg-lime-500 rounded-full absolute left-0 top-1/2 transform -translate-y-1/2" />
  )
}

function Header() {
  const [isFixed, setIsFixed] = useState(false);
  const location = useLocation();
  const isBoutique = location.pathname.startsWith('/Boutique');
  const { theme } = useContext(ThemeContext);
  const { isOpen, toggleOpen } = useContext(MenuContext);

  useEffect(() => {
    const handleScroll = () => {
      setIsFixed(window.pageYOffset > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const { t } = useTranslation();

  return (
    <div className='overflow-hidden'>
      <nav className={`fixed top-0 left-0 w-full flex items-center justify-between z-[100] backdrop-blur ${isFixed ? theme === 'dark' ? 'bg-black/50' : 'bg-white' : 'bg-transparent'}`}>

        <Link to={isBoutique ? "/Boutique" : "/"} className='flex items-center'>
          <Logo
            src={logo}
            alt="Logo safaridew"
            className={` max-h-6 ml-2 rounded-md ${isFixed ? 'w-20' : 'w-24'}
              `}
          />

          {
            isBoutique && (
              <div className="flex">
                <p className="text-black dark:text-lime-400 text-xs font-tight tracking-[0.3em] uppercase border border-lime-500 dark:border-lime-400 bg-lime-500 dark:bg-lime-500/20 rounded-[5px] p-1">
                  ◆Store
                </p>
              </div>
            )
          }
        </Link>

        {/* Liens pour desktop */}
        <div className={`hidden md:flex relative transition-all duration-300 ${isFixed ? 'scale-95' : ''}`}>
          <LinkNav to="/" theme={theme}>
            {t("Home")} {location.pathname === '/' && <Dot $active />}
          </LinkNav>
          {/* SHOP */}
          <LinkNav to="/Boutique" theme={theme}>
            {t("Boutique")} {isBoutique && <DotShop $active />}
          </LinkNav>

          {!isBoutique && (
            <LinkNav to="/About" theme={theme}>
              {t("About")} {location.pathname === '/About' && <Dot $active />}
            </LinkNav>
          )}
          {!isBoutique && (
            <LinkNav to="/Devis" theme={theme}>
              {t("Devis")} {location.pathname === '/Devis' && <Dot $active />}
            </LinkNav>
          )}

          <LinkNav to="/Contact" theme={theme}>
            {t("Contact")} {location.pathname === '/Contact' && <Dot $active />}
          </LinkNav>

          {
            !isBoutique && (
              <Lang />
            )
          }

        </div>


        <div className='relative flex items-center gap-1 md:hidden'>
          <Lang />
          <Hamburger />
        </div>
      </nav>
      {/* Liens pour mobile */}
      <div className={` text-xl fixed z-[101] top-0 right-0 bottom-0 flex flex-col justify-center backdrop-blur h-screen w-full md:hidden  transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'} ${theme === 'dark' ? 'bg-black/50' : 'bg-white/50'}`}>


        <LinkNav to="/" theme={theme} onClick={toggleOpen}> {t("Home")} {location.pathname === '/' && <Dot $active />}
        </LinkNav>
        <LinkNav to="/Boutique" theme={theme} onClick={toggleOpen}> {t("Boutique")} {isBoutique && <DotShop $active />}
        </LinkNav>

        {
          !isBoutique && (
            <LinkNav to="/About" theme={theme} onClick={toggleOpen}> {t("About")} {location.pathname === '/About' && <Dot $active />}</LinkNav>
          )
        }

        {
          !isBoutique && (
            <LinkNav to="/Devis" theme={theme} onClick={toggleOpen}> {t("Devis")} {location.pathname === '/Devis' && <Dot $active />}</LinkNav>
          )
        }

        <LinkNav to="/Contact" theme={theme} onClick={toggleOpen}> {t("Contact")} {location.pathname === '/Contact' && <Dot $active />}</LinkNav>

        {/* Close Menu */}
        <div className="fixed top-4 right-4" onClick={toggleOpen}>
          <Icon icon="solar:close-circle-bold-duotone" className='text-4xl' />
        </div>
      </div>


    </div>
  );
}

export default Header;
